import {
  REQUEST_USAGE_CLAIMS,
  SET_USAGE_CLAIMS,
} from 'containers/UsageClaimsPage/constants';

export const requestUsageClaims = (page: number, pageSize: number) => ({
  type: REQUEST_USAGE_CLAIMS,
  page,
  pageSize,
});

export const setUsageClaims = (response: any) => ({
  type: SET_USAGE_CLAIMS,
  response,
});
